import { useEffect, useRef, useState } from 'react';
import {
  DEFAULT_IN_APP_PAYWALL_CONFIG,
  getInAppPaywallConfig,
  type InAppPaywallDesign,
} from '@/features/subscription/remote-config/inAppPaywall';

const RESOLVE_TIMEOUT_MS = 1_500;

export const useInAppPaywallDesign = () => {
  const [design, setDesign] = useState<InAppPaywallDesign | null>(null);
  const isSettledRef = useRef(false);

  useEffect(() => {
    isSettledRef.current = false;

    const settle = (value: InAppPaywallDesign) => {
      if (isSettledRef.current) return;
      isSettledRef.current = true;
      setDesign(value);
    };

    const timer = setTimeout(
      () => settle(DEFAULT_IN_APP_PAYWALL_CONFIG.design),
      RESOLVE_TIMEOUT_MS
    );

    void getInAppPaywallConfig().then((config) => {
      clearTimeout(timer);
      settle(config.design);
    });

    return () => {
      isSettledRef.current = true;
      clearTimeout(timer);
    };
  }, []);

  return design;
};
